import React, { Fragment, Component, useRef, createRef } from 'react';
import Lightbox from 'react-images';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

class LightboxImages extends Component {
    constructor(props) {
        super(props)
        this.widthChange = this.widthChange.bind(this)
        this.scrollToSelectedThumbnail = this.scrollToSelectedThumbnail.bind(this);
        this.thumbnailsContainerRef = createRef();
        this.options = {
            showStatus: false,
            showThumbs: true,
            infiniteLoop: false,
            showArrows: true,
            thumbWidth: 90,
            emulateTouch: true,
            dynamicHeight: true,
            showIndicators: true,
            className: "carousel-with-modal",
        }
        // Add listener on media query.
        if (window.matchMedia) {
            const mq = window.matchMedia("(max-width: 639px)");
            mq.addListener(this.widthChange);
        }
    }

    componentDidMount() {
        this.widthChange();
        this.initMutationObserver();
    }

    // media query change
    widthChange() {
        if (window.innerWidth < 640) {
            this.options.centerSlidePercentage = 100;
            this.options.centerMode = true;
        } else {
            this.options.centerSlidePercentage = 100;
            this.options.centerMode = false;
        }
        this.forceUpdate();
    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    initMutationObserver = () => {
        const container = this.thumbnailsContainerRef.current;
        if (!container) return;

        this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.target.classList.contains('selected')) {
                    this.scrollToSelectedThumbnail();
                }
            });
        });

        const config = { attributes: true, childList: true, subtree: true };
        this.observer.observe(container, config);
    }

    scrollToSelectedThumbnail = () => {
        const container = this.thumbnailsContainerRef.current;
        if (!container) return;
    
        const selectedThumbnail = container.querySelector('.thumb.selected');
        if (!selectedThumbnail) return;
    
        const containerRect = container.getBoundingClientRect();
        const thumbRect = selectedThumbnail.getBoundingClientRect();
    
        const isOutsideLeft = thumbRect.left < containerRect.left;
        const isOutsideRight = thumbRect.right > containerRect.right;
    
        if (isOutsideLeft || isOutsideRight) {
            selectedThumbnail.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',    
                inline: 'center', 
            });
        }
    }

    render() {
        const customRenderThumb = (children) =>
        children.map((item, index) => {
            return <img itemProp="image" key={"thumb-"+index} src={this.props.thumbnails[index].src} alt={this.props.thumbnails[index].alt}></img>;
        });

        return (
            !this.props.images || this.props.images.length < 1 ? <Fragment /> :
                <Fragment>
                     {!this.props.hideCarousel && (
                        <div ref={this.thumbnailsContainerRef}> 
                            <Carousel
                                {...this.options}
                                selectedItem={this.props.currentImage}
                                onClickItem={(itemIndex) => this.props.onClickThumbnail(itemIndex)}
                                renderThumbs={customRenderThumb}
                                thumbWidth={90}
                            >
                                {this.props.images.map((value, index) => (
                                    <img itemProp="image" className="slider__image-container" key={`figure${index}`} src={value.imageHtml} alt={value.alt}></img>
                                ))}
                            </Carousel>
                        </div>
                    )}
                    <Lightbox
                        showThumbnails={true}
                        showImageCount={false}
                        {...this.props}
                    />
                </Fragment>
        )
    }
}
export default LightboxImages
